export const FIND_RESULT_FAILURE = 'FIND_RESULT_FAILURE';

export const findResultFailure = error => ({
    type: FIND_RESULT_FAILURE,
    payload: error,
    error: true,
});
